import { render } from "./fw05_Articles_Layout.vue?vue&type=template&id=ac562192&scoped=true"
import script from "./fw05_Articles_Layout.vue?vue&type=script&lang=js"
export * from "./fw05_Articles_Layout.vue?vue&type=script&lang=js"

import "./fw05_Articles_Layout.vue?vue&type=style&index=0&id=ac562192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac562192"]])

export default __exports__